import("../src/javascripts/attachments-redesign");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/navigation");
import("../src/javascripts/slider_splide");

$(document).ready(function () {
  const speed = 150;

  $(".Button--services-tab").on("click", function () {
    if ($(this).hasClass("active")) return;

    const industryType = $(this).data("industry");
    const $tabs = $(".Section--industry");

    $(`.Button--services-tab`).removeClass("active");
    $(this).addClass("active");

    $tabs.fadeOut(speed);
    industryType === "all" ? $tabs.fadeIn(speed) : $(`.Section--industry[data-industry="${industryType}"]`).fadeIn(speed);
  });
});
